import React from 'react';
import { useDisplayAmount } from '../../../../utils/PerkOptionsUtil';
import { RewardsTileMW, RewardsTileDTW, LoadingSkeletonVertical, ExpirationLine, } from '../../../shared/rewards-hub';
import { DrawerContext } from '../../../../contexts';
import { assets } from '../../../../images/AssetPaths';
import { useIsMobile } from '../../../../hooks';
import { ChallengeStepper } from '../../Drawer/ChallengeDrawer/ChallengeStepper';
import { ChallengeSentence } from '../../Drawer/ChallengeDrawer/ChallengeTile';
import { DrawerEventTriggers } from '../../../../utils/DrawerEventUtils';
var useGetIsMobile = function () { return useIsMobile().isMobile; };
export var LoadingTile = function () { return (React.createElement("div", { className: "sui-mb-6" },
    React.createElement(LoadingSkeletonVertical, { isMobile: useGetIsMobile(), hideBlock: true, hideLines: !useGetIsMobile(), disablePadding: true, lineCountDTW: 2, lineCountMW: 2 }))); };
export var ChallengeTile = function (_a) {
    var _b;
    var challenge = _a.challenge, isFirstTile = _a.isFirstTile;
    var openDetailsChallenge = React.useContext(DrawerContext).openDetailsChallenge;
    var RewardsTile = useGetIsMobile() ? RewardsTileMW : RewardsTileDTW;
    return (React.createElement(RewardsTile, { title: challenge === null || challenge === void 0 ? void 0 : challenge.name, subtitle: React.createElement(ChallengeSentence, { challenge: challenge }), iconUrl: (_b = challenge === null || challenge === void 0 ? void 0 : challenge.imageUrl) !== null && _b !== void 0 ? _b : assets.cardIcons.ChallengeIcon, 
        // pass the challenge as `data` so DrawerContext receives the expected shape
        containerCallback: function () { return openDetailsChallenge({ data: challenge }); }, isFirstTile: isFirstTile },
        React.createElement(ChallengeStepper, { steps: challenge === null || challenge === void 0 ? void 0 : challenge.challengeSteps, inListDrawer: true, activeStep: challenge === null || challenge === void 0 ? void 0 : challenge.challengeStepsCompleted })));
};
export var OfferTile = function (_a) {
    var perk = _a.perk, isFirstTile = _a.isFirstTile;
    var isMobile = useGetIsMobile();
    var _b = React.useContext(DrawerContext), openDetailsOffers = _b.openDetailsOffers, onDrawerClose = _b.onDrawerClose, isPacDrawersEnabled = _b.isPacDrawersEnabled;
    var getDisplayAmount = useDisplayAmount();
    var RewardsTile = isMobile ? RewardsTileMW : RewardsTileDTW;
    var eventOutput = {
        perkObj: perk,
        onClose: onDrawerClose,
    };
    var onClick = function () {
        if (isPacDrawersEnabled)
            DrawerEventTriggers.triggerRewardBarcodeDrawer(eventOutput);
        else
            openDetailsOffers({ perk: perk, eventOutput: eventOutput });
    };
    return (React.createElement(RewardsTile, { title: "".concat(getDisplayAmount(perk)).concat(perk.perkTitle), subtitle: React.createElement(ExpirationLine, { perk: perk, type: "Offer" }), iconUrl: perk.perkImageUrl, containerCallback: onClick, isFirstTile: isFirstTile }));
};
